export const PAYMENT_METHODS = [
  { value: 'card', label: 'Credit/Debit Card' },
  { value: 'cash', label: 'Cash' },
  { value: 'check', label: 'Check' },
  { value: 'ach', label: 'ACH / Bank Transfer' },
  { value: 'zelle', label: 'Zelle' },
  { value: 'venmo', label: 'Venmo' },
  // Account credit — drains the parent's customer_credits balance.
  // Handled specially by the Record Payment dialog: shows live balance
  // + how much will be applied, and routes a partial-paid registration
  // through the new `partial` payment_status when credit can't cover
  // the full fee.
  { value: 'account_credit', label: 'Account Credit' },
  { value: 'other', label: 'Other' },
];

export const EXPENSE_CATEGORIES = [
  { value: 'coach_travel', label: 'Coach Travel' },
  { value: 'coach_logistics', label: 'Coach Logistics' },
  { value: 'coach_hours', label: 'Coach Hours' },
  { value: 'coach_game_fee', label: 'Coach Game Fee' },
  { value: 'coach_meals', label: 'Coach Meals' },
  { value: 'tournament_registration', label: 'Tournament Registration' },
  { value: 'other', label: 'Other' },
];

export const statusColors = {
  future: 'bg-blue-100 text-blue-700',
  active: 'bg-green-100 text-green-700',
  closed: 'bg-yellow-100 text-yellow-700',
  past: 'bg-gray-100 text-gray-700',
};

export const registrationStatusColors = {
  pending: 'bg-yellow-100 text-yellow-700',
  selected: 'bg-blue-100 text-blue-700',
  payment_pending: 'bg-orange-100 text-orange-700',
  confirmed: 'bg-green-100 text-green-700',
  not_selected: 'bg-gray-100 text-gray-700',
  cancelled: 'bg-red-100 text-red-700',
  waitlisted: 'bg-purple-100 text-purple-700',
};

export const paymentStatusColors = {
  unpaid: 'bg-red-100 text-red-700',
  pending: 'bg-yellow-100 text-yellow-700',
  payment_pending: 'bg-blue-100 text-blue-700',
  processing: 'bg-blue-100 text-blue-700',
  partial: 'bg-amber-100 text-amber-700',
  paid: 'bg-green-100 text-green-700',
  refunded: 'bg-purple-100 text-purple-700',
};

export const EXPORT_FIELD_OPTIONS = [
  { key: 'player_name', label: 'Player Name', category: 'Basic' },
  { key: 'date_of_birth', label: 'Date of Birth', category: 'Basic' },
  { key: 'age', label: 'Age', category: 'Basic' },
  { key: 'gender', label: 'Gender', category: 'Basic' },
  { key: 'parent_name', label: 'Parent Name', category: 'Contact' },
  { key: 'parent_email', label: 'Parent Email', category: 'Contact' },
  { key: 'parent_phone', label: 'Parent Phone', category: 'Contact' },
  { key: 'payment_status', label: 'Payment Status', category: 'Registration' },
  { key: 'skill_level', label: 'Skill Level', category: 'Player Info' },
  { key: 'cricclubs_id', label: 'CricClubs ID', category: 'Player Info' },
  { key: 'cricclubs_email', label: 'CricClubs Email', category: 'Player Info' },
  { key: 'shirt_name', label: 'Shirt Name', category: 'Uniform' },
  { key: 'shirt_number', label: 'Shirt Number', category: 'Uniform' },
  { key: 'chest_size', label: 'Chest Size', category: 'Measurements' },
  { key: 'shirt_length', label: 'Shirt Length', category: 'Measurements' },
  { key: 'waist_size', label: 'Waist Size', category: 'Measurements' },
  { key: 'trouser_length', label: 'Trouser Length', category: 'Measurements' },
];
